import { stripPhoneNumberFormatting } from '@/core/utils/stripPhoneNumberFormatting';

export const formatPhoneNumber = (phoneNumber?: string) => {
  if (!phoneNumber) {
    return undefined;
  }

  return `+${stripPhoneNumberFormatting(phoneNumber)}`;
};
